import { render } from "./WebView.vue?vue&type=template&id=8ebc4c2c&ts=true"
import script from "./WebView.vue?vue&type=script&lang=ts"
export * from "./WebView.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/BV_HV/HeThongPVNB_HV/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__